import './less/main.less';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter } from 'react-router-dom';

import Main from './components/main';
import './components/ui-ant/misc/main.css';

import { runInitialJobs } from './components/ui-ant/misc/initial';

runInitialJobs();

const App = () => (
  <BrowserRouter>
    <Main />
  </BrowserRouter>
);

export default hot(App);



// WEBPACK FOOTER //
// ./src/app.js